<template>
  <div class="">
    <h1 v-if="loading" class="no-client text-center p-4 text-muted">
      <h2><i class="fa fa-spinner fa-spin"></i> Loading...</h2>
    </h1>
    <div v-else id="detail" class="card m-2 shadow-sm">
      <div v-if="!client.id" class="no-client">
        <h2>No Client Selected</h2>
      </div>
      <div v-if="client.id">
        <h4 class="p-2">
          <img :src="client.logo_url" style="width: 75px;" />
          {{ client.name }}
        </h4>

        <!-- <client-meta :client="client"></client-meta> -->
        <div class="">
          <ul class="nav nav-tabs">
            <li class="nav-item m-r" style="width: 15px;"></li>
            <li class="nav-item">
              <a class="nav-link active" href="#" data-toggle="tab" data-target="#products" aria-expanded="false">
                Products
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#" data-toggle="tab" data-target="#inbound" aria-expanded="true">
                Inbound
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#" data-toggle="tab" data-target="#outbound" aria-expanded="false">
                Outbound
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#" data-toggle="tab" data-target="#so" aria-expanded="false">
                Special Orders
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="#" data-toggle="tab" data-target="#rates" aria-expanded="false">
                Rates
              </a>
            </li>
          </ul>
        </div>

        <div class="tab-content bg-white">
          <div class="tab-pane active" id="products">
            <vue-good-table
              :columns="products.columns"
              :rows="products.rows"
              @on-row-click="goToProduct"
              :search-options="{
                enabled: true,
                trigger: 'enter',
                skipDiacritics: true,        
              }"
            ></vue-good-table>
          </div>
          <div class="tab-pane" id="inbound">
            <vue-good-table
              :columns="inbound.columns"
              :rows="inbound.rows"
              @on-row-click="goToInbound"
              :search-options="{
                enabled: true,
                trigger: 'enter',
                skipDiacritics: true,        
              }"
            ></vue-good-table>
          </div>
          <div class="tab-pane" id="outbound">
            <vue-good-table
              :columns="outbound.columns"
              :rows="outbound.rows"
              @on-row-click="goToOutbound"
              :search-options="{
                enabled: true,
                trigger: 'enter',
                skipDiacritics: true,        
              }"
            ></vue-good-table>  
          </div>
          <div class="tab-pane" id="so">
            <vue-good-table
              :columns="so.columns"
              :rows="so.rows"
              :search-options="{
                enabled: true,
                trigger: 'enter',
                skipDiacritics: true,        
              }"
            ></vue-good-table>  
          </div>
          <div class="tab-pane" id="rates">
            <rates :client="client"></rates>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { VueGoodTable } from 'vue-good-table'
import Rates from '@/components/clients/Rates.vue'
import api from '@/api'

export default {
  name: 'client-detail',

  components: {
    VueGoodTable,
    Rates
  },

  props: ['client'],

  data() {
    return {
      loading: false,
      inbound: {
        rows: [],
        columns: [
          { label: 'ID', field: 'id' },
          { label: 'PO', field: 'po_number' },
          { label: 'Container #', field: 'container_number' },
          { label: 'ETA',
            field: 'eta',
            type: 'date',
            dateInputFormat: 'yyyy-MM-dd\'T\'HH:mm:ss.SSS\'Z\'',
            dateOutputFormat: 'M/dd/yyyy'
          },
          { label: 'Received At', field: 'received_at' },
          { label: 'Status', field: 'status.name' },
        ]
      },
      outbound: {
        rows: [],
        columns: [
          { label: 'ID', field: 'id' },
          { label: 'PO', field: 'po_number' },
          { label: 'Destination', field: 'destination.name' },
        ]
      },
      so: {
        rows: [],
        columns: [
          { label: 'ID', field: 'id' }
        ]
      },
      products: {
        rows: [],
        columns: [
          {
            label: 'LM SKU',
            field: 'id'
          },
          {
            label: 'Client SKU',
            field: 'customer_sku'
          },
          {
            label: 'UPC',
            field: 'upc'
          },
          {
            label: 'Name',
            field: 'name'
          }
        ],
      }
    }
  },

  watch: {
    'client.id': function(id) {
      this.fetchData(id)
    }
  },

  created() {
    this.fetchData(this.client.id)
  },

  methods: {
    goToProduct(params) {
      this.$router.push(`/products/${params.row.id}`)
    },

    goToInbound(params) {
      this.$router.push(`/inbound/${params.row.id}`)
    },

    goToOutbound(params) {
      this.$router.push(`/outbound/${params.row.id}`)
    },
    
    fetchData(id) {
      this.loading = true
      api.get(`/clients/${id}/inbound-orders`).then(res => {
        this.inbound.rows = res.data.orders
      }),

      api.get(`/clients/${id}/outbound-orders`).then(res => {
        this.outbound.rows = res.data.orders
      }),

      api.get(`/clients/${id}/special-orders`).then(res => {
        this.so.rows = res.data.orders
      }),

      api.get(`/clients/${id}/products`).then(res => {
        this.products.rows = res.data.products
        this.loading = false
      })
    }
  }
}
</script>
<style scoped>
.no-client {
  text-align: center;
  display: flex;
  justify-content: center;
  align-content: space-around;
  height: calc(100vh - 48px);
  flex-direction: column;
}

.no-client h2 {
  justify-self: center;
  color: #cfcfcf;
}
</style>